import React, { forwardRef } from 'react'
import classNames from 'classnames'
import styles from './RadioButton.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

function RadioButton_({
  ...props
}, ref) {

  const { className, ...rest } = props;
  const childrenClassNames = classNames([
    generalStyle.general_style,
    styles.container,
    props.disabled && styles.disabled,
  ], className)

  return (
    <label
      className={childrenClassNames}
    >
      <input
        type="radio"
        ref={ref}
        {...rest}
      />
      <div className={classNames([styles.checkmark])} />
    </label>
  )
}

const RadioButton = forwardRef(RadioButton_);

export { RadioButton }
